import { MoreOptionsMenu, useDocumentTitle } from '@energy-stacks/shared';
import { useTranslation } from 'react-i18next';
import { TourDetails, TourInfo } from './TourDetails';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { TourInfoBanner } from './TourInfoBanner';
import { TourDetailsViewMode } from './TourDetailsViewModeButton';
import { EditTourMenuItem } from '../edit-tour/EditTourMenuItem';
import { TourDetailsActions } from './TourDetailsActions';
import { DeleteTourMenuItem } from '../DeleteTourMenuItem';

export const TourDetailsPage = ({
  onEnterEditMode,
  tourInfo,
}: {
  onEnterEditMode: () => void;
  tourInfo: TourInfo;
}) => {
  const [t] = useTranslation('tours');
  useDocumentTitle(t('pageTitle'));
  const [viewMode, setViewMode] = useState<TourDetailsViewMode>('table');

  return (
    <Stack sx={{ minHeight: '100%' }} gap={4}>
      <Stack direction="column" gap={6}>
        <TourDetailsActions
          shouldEnableFilters={true}
          vehicleName={tourInfo.vehicleName}
          tourStartDate={tourInfo.startDate}
          tourDetailsViewMode={viewMode}
          onTourDetailsViewModeChange={setViewMode}
        />
        <TourInfoBanner
          tourInfo={tourInfo}
          Actions={() => (
            <MoreOptionsMenu>
              <EditTourMenuItem
                onEnterEditMode={onEnterEditMode}
                status={tourInfo.tourStatus || 'PLANNED'}
              />
              <DeleteTourMenuItem
                tourId={tourInfo.id}
                tourStatus={tourInfo.tourStatus}
              />
            </MoreOptionsMenu>
          )}
        />
      </Stack>
      <TourDetails viewMode={viewMode} tourInfo={tourInfo} />
    </Stack>
  );
};
